import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  onClick,
  href
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    } else if (href && href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.a href={href || '#compra'} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-block bg-gold hover:bg-gold-hover text-white font-heading font-bold text-xl md:text-2xl py-4 px-8 rounded-sm shadow-[0_0_20px_rgba(34,197,94,0.3)] transition-colors text-center cursor-pointer ${className}`} data-id="element-345">
      {children}
    </motion.a>;
}